let checkoutPromise: Promise<void> | null = null;

export const loadRazorpayCheckout = () => {
  if (window.Razorpay) return Promise.resolve();
  if (checkoutPromise) return checkoutPromise;

  checkoutPromise = new Promise<void>((resolve, reject) => {
    const existingScript = document.querySelector<HTMLScriptElement>('script[data-razorpay-checkout]');
    const script = existingScript || document.createElement('script');
    const timeoutId = window.setTimeout(() => {
      checkoutPromise = null;
      reject(new Error('Razorpay Checkout timed out while loading.'));
    }, 15_000);

    script.onload = () => {
      window.clearTimeout(timeoutId);
      if (!window.Razorpay) {
        checkoutPromise = null;
        reject(new Error('Razorpay Checkout did not initialize.'));
        return;
      }
      resolve();
    };
    script.onerror = () => {
      window.clearTimeout(timeoutId);
      checkoutPromise = null;
      reject(new Error('Razorpay Checkout could not be loaded.'));
    };

    if (!existingScript) {
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.async = true;
      script.dataset.razorpayCheckout = 'true';
      document.body.appendChild(script);
    }
  });

  return checkoutPromise;
};